import React from 'react';
import PropTypes from 'prop-types';

function Icon({ width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 192 192"
      width={width}
      height={height}
    >
      <path
        fill="#aec6cf"
        d="M96 184c-48.5 0-88-39.5-88-88S47.5 8 96 8s88 39.5 88 88-39.5 88-88 88zm0-166.3c-43.9 0-79.6 35.6-79.6 79.3s35.7 85.8 79.6 85.8 79.6-42.1 79.6-85.8S139.9 17.7 96 17.7z"
      />
      <path
        fill="#ffb347"
        d="M96 182.8c-39.8 0-72.2-32.4-72.2-72.2S56.2 38.5 96 38.5s72.2 32.4 72.2 72.2-32.4 72.1-72.2 72.1zm0-136.4c-35.9 0-65.2 29.1-65.2 64.9S60 181.6 96 181.6s65.2-34.5 65.2-70.3S131.9 46.4 96 46.4z"
      />
      <path
        fill="#88d8c0"
        d="M96 181.6c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56zm0-105.9c-28 0-50.7 22.6-50.7 50.5S68 180.3 96 180.3s50.7-26.4 50.7-54.2S124 75.7 96 75.7z"
      />
    </svg>
  );
}

Icon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Icon.defaultProps = {
  width: 48,
  height: 48,
};

export default Icon;
